export const parseTrainingPartVersionCode = versionCode => {
  const normalized = String(versionCode || '').trim();
  const dotIndex = normalized.indexOf('.');

  if (dotIndex <= 0 || dotIndex === normalized.length - 1) {
    return {
      versionCode: normalized,
      version: '',
      revision: '',
      isValid: false,
    };
  }

  return {
    versionCode: normalized,
    version: normalized.slice(0, dotIndex).trim(),
    revision: normalized.slice(dotIndex + 1).trim(),
    isValid: true,
  };
};
